import { Component, h, Prop, Listen, State } from '@stencil/core';
import type { ComponentInterface } from '@stencil/core';

@Component({
  tag: 'app-alert-banner'
})
export class AlertBanner implements ComponentInterface {

	/**
	 * Assigns a required unique id to the banner alert
	 */
	@Prop() alertId: string = "alertBannerId";

	/**
	 * Provides a string for any additional alert classes
	 */
	@Prop() alertClasses: string = "alert-primary";

	/**
	 * Add an icon to the banner
	 */
	@Prop() alertIcon: string;

	/**
	 * If true adds dismissible button and dismiss function
	 */
	@Prop() dismissible: boolean = false;

	/**
	 * Determines if alert should render depending on if the user dismissed it
	 */
	@State() shouldRender: boolean = true;

	/**
	 * When event is emitted set session storage.
	 */
	@Listen('dismissTriggered')
	handleDismissTriggered() {
		sessionStorage.setItem('alert-' + this.alertId, "dismissed");
	}

	componentWillLoad() {
		if (this.dismissible) {
			this.shouldRender = sessionStorage.getItem(`alert-${this.alertId}`) !== "dismissed";
		}
	}

	render() {
		if (this.shouldRender) {
			return (
				<app-alert 
					alert-id={this.alertId} 
					alert-classes={this.alertClasses} 
					alert-icon={this.alertIcon}
					dismissible={this.dismissible}>
					<slot />
				</app-alert>	
			);
		} else {
			return (
				<div class="d-none">
					<slot />
				</div>
			);
		}
	}
}